import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { GithubProvider } from './context/GithubContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import EditorPage from './pages/EditorPage';
import RepositoriesPage from './pages/RepositoriesPage';
import AuthCallbackPage from './pages/AuthCallbackPage';

const App: React.FC = () => {
  return (
    <GithubProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/editor" element={<EditorPage />} />
            <Route path="/repositories" element={<RepositoriesPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
          </Routes>
        </main>
        
        <footer className="bg-dark text-white py-6">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="mb-4 md:mb-0">
                <p>&copy; {new Date().getFullYear()} GitHub HTML Tool</p>
              </div>
              
              <div className="flex space-x-6">
                <a 
                  href="https://github.com/features/actions" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-gray-300"
                >
                  GitHub Actions
                </a>
                <a 
                  href="https://developers.cloudflare.com/pages/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-gray-300"
                >
                  Cloudflare Pages
                </a>
                <a 
                  href="https://docs.github.com/en/rest" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-gray-300"
                >
                  GitHub API
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </GithubProvider>
  );
};

export default App; 